import React from "react";
import "../count-icon.scss";
import { WedIcon } from "../../wed-icon/WedIcon";
import { WedIconMessagesChat5 } from "../../wed-icon/generated/WedIconSvg";

interface PropsInterface {
    count: number;
}

interface StateInterface {}

export default class CommentsCountIcon extends React.Component<PropsInterface, StateInterface> {
    render() {
        const { count } = this.props;

        return (
            <div className="count-icon comments-count-icon">
                <WedIcon icon={<WedIconMessagesChat5 />} />
                <span className="count-icon__content">{count}</span>
            </div>
        );
    }
}
